module.exports = __webpack_public_path__ + "static/media/pa-green.f008d29f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pa-green.svg
// module id = 879
// module chunks = 0